<template>
  <div class="comments">
    <div class="comments__list" id="comments__list">
      <template v-if="comments.length === 0 && showNothing">

        <div class="comments__item">
          <div class="comments__avatar avatar"></div>
          <div class="comments__name"></div>
          <div class="staff__btns comments__btns"></div>
          <div class="comments__text">{{ $vuetify.lang.t("$vuetify.noDataText") }}</div>
        </div>
      </template>
      <CommentComponent
          v-for="com in comments.filter(com=>com.parent_comment == null)" :key="com.id"
          :com="com"
          :comments="comments"
          :table="table"
          :hide-edit="hideEdit"
          :hide-reply="hideReply"
          @answerStart="answerStart"
          @editOpen="edit_comment_open"
          @deleteComment="deleteComment"
          @pushCommentFile="pushCommentFile"
          @openLightbox="openLightbox"
      ></CommentComponent>
    </div>
    <div v-if="newComment.id" class="flex justify-between">
      <span class="bolder">{{ $vuetify.lang.t("$vuetify.editingComment") }}</span>
      <button class="btn-icon" @click="cancel_edit_comment">
        <v-icon>mdi-close</v-icon>
      </button>
    </div>
    <v-form :disabled="!active" class="comments__input" ref="comment" @submit.prevent=""
            style="max-height: 50%">
      <button :disabled="!active" class="cp" @click="clickInput">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M3.39181 20.5C2.52112 20.5 1.74789 20.1506 1.07212 19.4517C0.357375 18.7126 0 17.8155 0 16.7605C0 15.7056 0.357375 14.8085 1.07212 14.0693L12.2807 1.77245C12.8525 1.16768 13.512 0.777947 14.2593 0.603238C15.0065 0.428528 15.7635 0.475565 16.5302 0.744349C17.2969 1.01313 18.0052 1.47679 18.655 2.13531C18.8629 2.36378 19.0546 2.61576 19.23 2.89126C19.4055 3.16677 19.5484 3.45571 19.6589 3.75809C19.7693 4.06048 19.8538 4.37966 19.9123 4.71564C19.9708 5.05162 20 5.3876 20 5.72358C19.974 7.14814 19.5062 8.33751 18.5965 9.29169L10.117 18.6051C10 18.7395 9.85705 18.81 9.68811 18.8167C9.51917 18.8235 9.37297 18.7663 9.24951 18.6454C9.12606 18.5244 9.06108 18.3732 9.05458 18.1918C9.04808 18.0104 9.10331 17.8525 9.22027 17.7181L17.6998 8.4047C18.3886 7.67899 18.7394 6.77856 18.7524 5.70342C18.7654 4.62828 18.434 3.74801 17.7583 3.06261C17.3424 2.61912 16.8811 2.28314 16.3743 2.05467C15.8674 1.82621 15.3216 1.75229 14.7368 1.83293C14.152 1.91356 13.6322 2.18907 13.1774 2.65944L1.96881 14.9563C1.48798 15.4536 1.24756 16.0516 1.24756 16.7505C1.24756 17.4493 1.48798 18.0473 1.96881 18.5446C2.18973 18.7731 2.43015 18.9444 2.69006 19.0586C2.94997 19.1729 3.22287 19.2166 3.50877 19.1897C4.08057 19.1628 4.61339 18.8873 5.10721 18.3632L14.0156 8.56597C14.0806 8.49878 14.1423 8.42822 14.2008 8.35431C14.2593 8.28039 14.321 8.19304 14.386 8.09224C14.4509 7.99145 14.5029 7.88393 14.5419 7.7697C14.5809 7.65547 14.6069 7.54123 14.6199 7.427C14.6329 7.31277 14.6134 7.19517 14.5614 7.07422C14.5094 6.95327 14.4314 6.83904 14.3275 6.73152C14.0806 6.46274 13.8402 6.34178 13.6062 6.36866C13.3593 6.39554 13.0799 6.56353 12.768 6.87263L6.06238 14.2508C5.98441 14.3314 5.89344 14.3885 5.78947 14.4221C5.68551 14.4557 5.5783 14.4591 5.46784 14.4322C5.35738 14.4053 5.26316 14.3516 5.18518 14.2709C5.05523 14.15 4.99025 14.0021 4.99025 13.8274C4.99025 13.6527 5.04873 13.4982 5.16569 13.3638L11.8713 5.96549C12.4042 5.42792 12.9435 5.13225 13.4893 5.0785C14.1131 5.02474 14.6849 5.26665 15.2047 5.80422C15.6985 6.30147 15.9162 6.88607 15.8577 7.55803C15.7992 8.22999 15.4841 8.86164 14.9123 9.45296L6.0039 19.2703C5.27615 20.0229 4.46394 20.4261 3.56725 20.4798C3.54126 20.4798 3.51202 20.4832 3.47953 20.4899C3.44704 20.4966 3.4178 20.5 3.39181 20.5Z"
              fill="#ADB2B7"/>
        </svg>
      </button>
      <v-file-input :disabled="!active" class="file-input--hide" v-model="commentPhoto"
                    placeholder="Загрузить изображение (jpg, png)" id="photo" multiple
                    @change="showFile(this)" :rules="[$rules.multipleFileSize]">
      </v-file-input>
      <v-textarea :disabled="!active" v-model="newComment.text"
                  :label="$vuetify.lang.t('$vuetify.enterText')" outlined
                  id="textarea" row-height="15" auto-grow rows="1"
                  append-icon="mdi-emoticon-happy-outline">
        <template v-slot:append>
          <v-menu v-model="show_smiles" top left close-on-content-click offset-y attach>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="show_smiles=!show_smiles" v-bind="attrs" v-on="on">
                <v-icon>mdi-emoticon-happy-outline</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text style="width: 195px; font-size: large;">
                <span class="cp" @click.stop="enterSmile('😀')">😀</span>
                <span class="cp" @click.stop="enterSmile('😉')">😉</span>
                <span class="cp" @click.stop="enterSmile('😂')">😂</span>
                <span class="cp" @click.stop="enterSmile('😡')">😡</span>
                <span class="cp" @click.stop="enterSmile('😱')">😱</span>
                <span class="cp" @click.stop="enterSmile('🤨')">🤨</span>
                <span class="cp" @click.stop="enterSmile('😍')">😍</span>
                <span class="cp" @click.stop="enterSmile('👌')">👌</span>
                <span class="cp" @click.stop="enterSmile('👍')">👍</span>
                <span class="cp" @click.stop="enterSmile('👎')">👎</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
      </v-textarea>

      <button :disabled="!active" class="cp" @click="submitComment">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M1.26593 0.96077L19.6919 10.04C19.7924 10.0895 19.877 10.1661 19.9362 10.2613C19.9954 10.3564 20.0267 10.4662 20.0267 10.5782C20.0267 10.6902 19.9954 10.8 19.9362 10.8951C19.877 10.9902 19.7924 11.0669 19.6919 11.1164L1.26473 20.1956C1.1615 20.2463 1.04586 20.2663 0.9316 20.2531C0.817337 20.24 0.70926 20.1942 0.620241 20.1214C0.531223 20.0486 0.465014 19.9517 0.429501 19.8423C0.393987 19.7329 0.390666 19.6156 0.419932 19.5044L2.78273 10.5836L0.418732 1.65317C0.388982 1.54171 0.391995 1.42403 0.427412 1.31424C0.462829 1.20444 0.529147 1.10719 0.618423 1.03412C0.707699 0.961055 0.816147 0.915275 0.930775 0.902265C1.0454 0.889256 1.16135 0.909568 1.26473 0.96077H1.26593ZM1.91753 2.62037L3.84953 9.91877L3.92393 9.90437L4.00073 9.89957H8.20073H12.4007C12.5507 9.89929 12.6953 9.95516 12.8061 10.0562C12.9169 10.1572 12.9858 10.296 12.9994 10.4454C13.0129 10.5947 12.9701 10.7437 12.8793 10.863C12.7885 10.9823 12.6563 11.0633 12.5087 11.09L12.4007 11.0996H8.20073H4.00073C3.96372 11.0997 3.92676 11.0965 3.89033 11.09L1.91873 18.5372L18.0683 10.5788L1.91753 2.62037Z"
              fill="#ADB2B7"/>
        </svg>
      </button>
    </v-form>
    <v-progress-linear :class="{form__progress : form_loader}"
                       :active="form_loader"
                       indeterminate
                       rounded
                       height="6"
    ></v-progress-linear>
    <div v-if="newComment.parent_comment">{{ $vuetify.lang.t('$vuetify.answer') }}</div>
    <div class="comments__photo flex" id="list"
         v-if="photoHtml.length + filesHtml.length + editingFiles.length">
      <div v-for="src in photoHtml" :key="src">
        <img :src="src" alt="photo" @click="showEdit(src)"/>
        <button class="btn-icon" @click="deleteFile(src)">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <div v-for="name in filesHtml" class="file flex" :key="name">
        <img v-bind="attrs" v-on="on" src="../../assets/img/document-preview.svg" alt="">
        <button class="btn-icon" @click="deleteFile(name)">
          <v-icon>mdi-close</v-icon>
        </button>
        <span>{{ name }}</span>
      </div>
      <template v-if="newComment.id">
        <div v-for="doc in editingFiles" :key="doc">
          <button class="btn-icon" @click="deleteFile(doc)">
            <v-icon>mdi-close</v-icon>
          </button>
          <img
              v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1)))"
              :src="$media_url + doc" alt="photo"/>
          <v-tooltip top v-else :key="doc">
            <template v-slot:activator="{ on, attrs }">
              <img v-bind="attrs" v-on="on" class="document-row__photo"
                   src="../../assets/img/document-preview.svg"
                   alt="">
            </template>
            <span>{{
                doc.substr(doc.lastIndexOf('/') + 1, doc.lastIndexOf('_') + 1) + doc.substr(doc.lastIndexOf('.'))
              }}</span>
          </v-tooltip>
        </div>
      </template>
    </div>
    <div class="error--text" v-if="alertError">{{ alertMsg }}</div>



    <CoolLightBox
        :items="lightboxItems"
        :index="index"
        @close="index = null">
    </CoolLightBox>

    <ConfirmModal v-model="confirm_document_modal" @confirm="deleteDocument">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
  </div>
</template>

<script>
import CommentComponent from "@/components/CommentComponent.vue";
import ConfirmModal from "@/components/confirmModal.vue";
import {mapGetters} from "vuex";

export default {
  name: "CommentList",
  components: {ConfirmModal, CommentComponent},

  props: {
    table: String,
    id: String,
    showNothing: {
      type: Boolean,
      default: true
    },
    hideEdit:{
      type: Boolean,
      default: false,
    },
    hideReply:{
      type: Boolean,
      default: false,
    },
  },

  data: function (){
    return {
      lightboxItems: [],

      comments: [],
      profile: Number.parseInt(localStorage.getItem('user')),
      translated: [],
      show_smiles: false,


      newComment: {
        text: "",
        files: [],
        parent_comment: ""
      },

      editingFiles: [],
      deletedFiles: [],
      commentPhoto: [],
      commentPhotoRow: [],
      photoHtml: [],
      filesHtml: [],
      comment_to_delete: 0,

      alertMsg: "",
      alertError: false,

      form_loader: false,
      confirm_document_modal: false,
      index: null,


    }
  },

  mounted() {
    this.loadComments()
  },

  methods: {

    scrollComments() {
      this.$nextTick(() => {
        setTimeout(()=>{
          document.getElementById("comments__list").scrollTop =
              document.getElementById("comments__list").scrollHeight;
      }, 150);
      })

    },

    downloadDocument(item) {
      if (item.path.length === 1 && (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(item.path[0].substr(item.path[0].lastIndexOf('.') + 1)))) {
        this.lightboxItems.push(this.$media_url + item.path[0])
        this.index = 0
      } else {
        let path = ''
        if (item.zip) {
          path = item.zip
        } else {
          path = item.path[0]
        }
        let name = path.substr(path.lastIndexOf('/') + 1, path.lastIndexOf('_')) + path.substr(path.lastIndexOf('.'))
        this.$axios({
          url: this.$hostname + 'media/' + path,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', name);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
      }
    },

    openLightbox(id, index) {
      let com = this.comments.find(el=> el.id==id)
      this.index = this.lightboxItems.findIndex(file => {
        return file == (this.$media_url + com.files[index])
      })
    },
    addComment() {
      this.form_loader = true
      if (this.newComment.id) {
        this.putComment()
      } else {
        this.newComment.objects_id = this.id;
        this.newComment.files = JSON.stringify(this.commentPhotoRow)
        this.$axios({
          url: this.$hostname + "time-tracking/comments/"+this.table+"/"+this.id,
          method: "POST",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newComment,
        })
            .then(() => {
              // this.comments.push(this.newComment)
              this.loadComments();
              this.newComment = {
                text: "",
                files: [],
                parent_comment: null,
                objects_id: null,
              };
              this.commentPhoto = [];
              this.commentPhotoRow = [];
              this.photoHtml = [];
              this.filesHtml = [];
              this.deletedFiles = [];
            })
            .catch((response) => {
              this.alertMsg = this.$catch(response);
              this.alertError = true;
            }).finally(() => {
          this.form_loader = false
        });
      }
    },
    putComment()  {
      this.newComment.files = JSON.stringify(this.editingFiles.concat(this.commentPhotoRow))
      this.$axios({
        url: this.$hostname + "time-tracking/comments/"+this.table+"/" +this.id,
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newComment,
      })
          .then(() => {
            this.loadComments();
            this.cancel_edit_comment()
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).finally(() => {
        this.form_loader = false
      });
    },
    deleteComment(comment_to_delete) {
      this.$axios({
        url: this.$hostname + "time-tracking/comments/"+this.table + "/" + this.id,
        method: "DELETE",
        data: {
          id: comment_to_delete,
        },
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
        this.$forceUpdate()
        this.loadComments();
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    answerStart(id) {
      this.newComment.parent_comment = id
      this.newComment.parent_comment = id
      this.$forceUpdate()
    },
    edit_comment_open(id) {
      console.log(id)
      let com = this.comments.find(el=> el.id==id)
      this.newComment = structuredClone(com)
      this.editingFiles = structuredClone(com.files)
    },
    cancel_edit_comment() {
      this.newComment = {
        text: "",
        files: [],
        parent_comment: null,
        objects_id: null,
      };
      this.commentPhoto = [];
      this.commentPhotoRow = [];
      this.photoHtml = [];
      this.filesHtml = [];
      this.deletedFiles = [];
    },
    deleteFile(file) {
      if (this.newComment.id) {
        let idx = this.newComment.files.findIndex(doc => {
          return doc === file
        })
        let idx_edit = this.editingFiles.findIndex(doc => {
          return doc === file
        })
        if (idx !== -1) {
          this.deletedFiles.push(file)
          this.newComment.files.splice(idx, 1)
        }
        if (idx_edit !== -1) {
          this.editingFiles.splice(idx_edit, 1)
        }
      }

      var idx = this.commentPhoto.findIndex(f => {
        if (!f.type.match("image.*")) {
          return f.name == file
        } else {
          var fr = new FileReader();
          fr.onload = (() => {
            return (e) => {
              return e.target.result
            };
          })(f);
          return f.src == file
        }
      })
      if (idx > -1) {
        this.commentPhoto.splice(idx, 1)
      }

      ['photoHtml', 'filesHtml'].forEach((propertyName) => {
        const index = this[propertyName].findIndex(f => {
          return f === file;
        });
        if (index > -1) {
          this[propertyName].splice(index, 1);
        }
      });
      this.$forceUpdate()
    },
    parseCommentFiles(com) {
      if (com.files != null && com.files != '') {
        com.files = JSON.parse(com.files);
        for (let i = 0; i < com.files.length; i++) {
          if (['png', 'jpg', 'jpeg'].includes(com.files[i].substr(com.files[i].lastIndexOf('.') + 1).toLowerCase())) {
            this.lightboxItems.push(this.$media_url + com.files[i]);
          }
        }
      }
    },
    async downloadCommentFiles(com) {
      this.loader = true
      for (let i = 0; i < com.files.length; i++) { // Используем цикл for, чтобы работал await
        const file = com.files[i];
        let name = file.substring(file.lastIndexOf('/') + 1, file.lastIndexOf('_')) + file.substring(file.lastIndexOf('.'));
        if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(file.substring(file.lastIndexOf('.') + 1))) {
          await this.$axios({
            url: this.$hostname + 'media/' + file,
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', name);
            document.body.appendChild(fileLink);

            fileLink.click();

            // Удаляем ссылку после клика
            document.body.removeChild(fileLink);
          }).catch((error) => {
            this.alertMsg = this.$catch(error)
            this.alertError = true
          });

          // Добавляем задержку перед загрузкой следующего файла
          await new Promise(resolve => setTimeout(resolve, 100)); // Задержка 100 мс
        }
      }
      this.loader = false
    },
    uploadFile(file) {
      return this.$axios({
        url: this.$hostname + "time-tracking/images/upload/objects",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
          .then((response) => {
            this.commentPhotoRow.push(response.data.data)
          })
          .catch((error) => {
            alert("Ошибка загрузки файла: " + error.message);
          });

      // await new Promise(resolve => setTimeout(resolve, 100)); // Задержка 100 мс
    },
    submitComment() {
      if (this.$refs.comment.validate()) {
        if (this.commentPhoto.length) {
          this.loader = true
          let promises = []
          this.commentPhoto.forEach((photo) => {
            promises.push(this.uploadFile(photo));
          });

          Promise.all(promises).then(()=>{

          this.loader = false
          this.addComment();
          })

        } else this.addComment();
      } else {
        this.alertMsg = "Слишком большой файл"
        this.alertError = true
      }
    },
    enterSmile(smile) {
      this.newComment.text += smile
      this.show_smiles = false
    },
    clickInput() {
      document.getElementById("photo").click();
    },
    // eslint-disable-next-line no-unused-vars
    showFile(e) {
      var files = this.commentPhoto;
      this.filesHtml = [];
      this.photoHtml = [];
      // eslint-disable-next-line no-cond-assign
      for (var i = 0, f; (f = files[i]); i++) {
        if (!f.type.match("image.*")) {
          this.filesHtml.push(f.name)
        } else {
          var fr = new FileReader();
          fr.onload = (() => {
            return (e) => {
              this.photoHtml.push(e.target.result);
            };
          })(f);
          fr.readAsDataURL(f);
        }
      }
    },

    loadComments(){

      this.$axios({
        url: this.$hostname + "time-tracking/comments/"+this.table+"/" + this.id,
        type: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      })
          .then((response) => {
            this.comments = response.data.data.data;
            this.comments.forEach(com => {
              this.parseCommentFiles(com)
            })
          })
    },
    deleteDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/documents/" + this.id,
        method: "DELETE",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.document_to_delete
        },
      })
          .then(() => {
            this.loadData();
            this.confirm_document_modal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    pushCommentFile(file){
      this.lightboxItems.push(file);

    }
  },
  
  computed: {
    ...mapGetters(['active'])
  },

  watch: {

    comments() {
      console.log('watch')
      this.scrollComments();
    },
  }

}
</script>
